import React from 'react';

export const CurrencyOutput: React.FC<{ value?: number; }> = (props) => {
  const { value } = props;

  if (!value) return <>-</>;

  const currency = value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return <>{currency}</>;
};

export const currencyOutputNumber = (value: number, maximumFractionDigits: number = 2) => {
  if (isNaN(value)) return "-";

  return value?.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: maximumFractionDigits
  });
};